import React, { useContext } from "react";
import { Typography, Menu, MenuItem, ListItemIcon, Fade, Hidden } from "@material-ui/core";
import ImportIcon from "@material-ui/icons/PublishTwoTone";
import ExportIcon from "@material-ui/icons/GetAppTwoTone";
import ImportTemplateIcon from "@material-ui/icons/ImportExportTwoTone";
import LabelIcon from "@material-ui/icons/Label";
import translate from "../i18n/Translator";
import { AppContext } from "../context/AppContext";

interface CustomersMenuProps {
    anchor: HTMLElement | null;
    totalItems?: number;
    onClose(): any;
    onImportCustomers(): any;
    onDownloadCustomers(): any;
    onClassify(): any;
}

export default function CustomersMenu(props: CustomersMenuProps) {
    const context = useContext(AppContext);

    return (
        <Menu
            id="customers-menu"
            anchorEl={props.anchor}
            keepMounted
            onClose={props.onClose}
            open
            TransitionComponent={Fade}
            autoFocus={false}
            variant="selectedMenu"
        >
            {context.isGranted("CustomersCreate") &&
                <div>
                    <Hidden implementation="css" smUp>
                        <MenuItem button onClick={props.onImportCustomers} dense>
                            <ListItemIcon>
                                <ImportIcon fontSize="small" color="primary" />
                            </ListItemIcon>
                            <Typography variant="inherit">{translate("buttons.import_customers")}</Typography>
                        </MenuItem>
                    </Hidden>
                </div>
            }
            {context.isGranted("CustomersCreate") &&
                <MenuItem button onClick={props.onClose} dense component="a" href="/plantilla-importacion-clientes.zip" target="_blank" rel="noopener noreferrer">
                    <ListItemIcon>
                        <ImportTemplateIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.download_template_customers")}</Typography>
                </MenuItem>
            }
            <MenuItem button onClick={props.onDownloadCustomers} dense disabled={props.totalItems === undefined || props.totalItems === 0}>
                <ListItemIcon>
                    <ExportIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <Typography variant="inherit">{translate("buttons.download_customers")}</Typography>
            </MenuItem>
            {context.isGranted("CustomersUpdate") &&
                <MenuItem button onClick={props.onClassify} dense>
                    <ListItemIcon>
                        <LabelIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.classify_customers")}</Typography>
                </MenuItem>
            }
        </Menu>
    );

} 